// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Loadable, Loaded } from '@app/core';
import { userRolesMock, userGroupsMock } from './user-details.mock';


export interface UserDetailsState {
    [userId: string]: {
      details: Loadable | Loaded<UserDetailsData>;
    };
}
export interface UserDetailsData {
    user: UserState;
}

export interface UserState {
    id: string;
    name: string;
    email: string;
    username: string;
    accountName: string;
    roles?: UserRoleState[];
    groups?: UserGroupsState[];
}

export interface UserRoleState {
    id: string;
    name: string;
    scope_id: string;
    scope_name: string;
    constraint_id: string;
    constraint_name: string;
}

export interface UserGroupsState {
    id: string;
    name: string;
    user_group_id: string;
    account_id: string;
    account_name: string;
}


export class UserDetailsModel {
    username: string;
    name: string;
    accountName: string;
    roles: UserRolesResponse[];
    groups: any[];

    constructor(data: UserDetailsResponse) {

        Object.assign(this, {...data});

        this.username = data.user_name;
        this.name = `${data.first_name} ${data.last_name}`;
        this.accountName = data.account_name;

        this.roles = [];
        this.groups = [];
    }
}


export interface UserDetailsResponse {
  id: string;
  sf_id: string;
  user_name: string;
  first_name: string;
  last_name: string;
  email: string;
  account_id: string;
  account_name: string;
  roles?: UserRolesResponse[];
  groups?: UserGroupsResponse[];

}

export interface UserRolesResponse {
    id: string;
    name: string;
    scope_id?: string;
    scope_name?: string;
    constraint_id?: string;
    constraint_name?: string;
}

export interface UserGroupsResponse {
    id: string;
    name: string;
    user_group_id: string;
    account_id: string;
    account_name: string;
}


export interface UserGroupsCreateRequest {
    group_ids: string[];
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/user-details/user-details.interfaces.ts